import { Tag, Tooltip } from "antd";
import React from "react";
import {
  JobPostingStatusEnum,
  JobPostingStatusLabel,
} from "Constants/Enums/JobPostingStatusEnum";

const columns = [
  {
    title: "Post_Name",
    dataIndex: "PositionName",
    key: "PositionName",
    render: (text) => {
      if (!text) return "N/A"; // safeguard
      return (
        <Tooltip title={text}>
          <span
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              maxWidth: 100,
              display: "inline-block",
            }}
          >
            {text.length > 10 ? `${text.slice(0, 10)}...` : text}
          </span>
        </Tooltip>
      );
    },
  },
  {
    title: "Department",
    dataIndex: "departmentName",
    key: "departmentName",
    render: (text) => {
      if (!text) return "N/A";
      return (
        <Tooltip title={text}>
          <span
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              maxWidth: 100,
              display: "inline-block",
            }}
          >
            {text.length > 5 ? `${text.slice(0, 5)}...` : text}
          </span>
        </Tooltip>
      );
    },
  },
  {
    title: "Created_On",
    dataIndex: "createdOn",
    key: "createdOn",
  },
  {
    title: "Skills",
    dataIndex: "skills",
    key: "skills",
    render: (skills) => {
      if (!skills || skills === "N/A") return "N/A";

      const skillsArray = Array.isArray(skills) ? skills : skills.split(" ");

      const skillsList = (
        <ul style={{ margin: 0, paddingLeft: 20 }}>
          {skillsArray.map((skill, index) => (
            <li key={index}>{skill}</li>
          ))}
        </ul>
      );

      return (
        <Tooltip title={skillsList}>
          <span
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              maxWidth: 100,
              display: "inline-block",
            }}
          >
            {skillsArray.slice(0, 2).join(" ")}...
          </span>
        </Tooltip>
      );
    },
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (status) => {
      const isFilled = status === JobPostingStatusEnum.Filled;
      return (
        <Tag
          color={isFilled ? "green" : "blue"}
          style={{ borderRadius: 40, padding: "0 12px", fontWeight: 600 }}
        >
          {JobPostingStatusLabel[status] || "Open"}
        </Tag>
      );
    },
  },
  {
    title: "View Candidate",
    dataIndex: "ViewCandidate",
    key: "ViewCandidate",
  },
  {
    title: "Action",
    dataIndex: "Action",
    key: "Action",
  },
];

export default columns;
